export enum APIStatusEnum {
    Unauthorized = 401,
    NotFound = 404,
    Forbidden = 403,
    UnprocessableEntity = 422,
    Found = 302,
    TooManyRequests = 429,
    NoContent = 204
}

export enum APIErrorCodeEnum {
    NeedResetPassword = 9,
}
